import { render, staticRenderFns } from "./ValidationTags.vue?vue&type=template&id=6c3be0f3"
import script from "./ValidationTags.vue?vue&type=script&lang=js"
export * from "./ValidationTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports